<template>
  <div>
    <div class="vx-col w-full">
      <ul class="heading-ul mb-5">
        <li>
          <router-link to="/setup/broadcaster-channel" class="vx-row">
            <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
            <h4>{{ $t("setup.label.EditChannel") }}</h4>
          </router-link>
        </li>
      </ul>
    </div>
    <ValidationObserver ref="observer">
      <div class="vx-row">
        <vx-card title card-border>
          <div class="vx-row">
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('setup.label.ChannelName')"
              >
                <vs-input
                  :label="$t('setup.label.ChannelName')"
                  class="w-full mb-2 font-semibold"
                  v-model="channelInfo.channelName"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label font-semibold">{{
                  $t("setup.label.Language")
                }}</small>
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('setup.label.Language')"
                >
                  <v-select
                    label="name"
                    v-model="channelInfo.language"
                    :options="channelTemplate.languageEnum"
                    :placeholder="$t('placeholder.label.SelectOne')"
                  >
                    <template v-slot:option="option">{{
                      option.name
                    }}</template></v-select
                  >
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="vx-col w-full" style="margin: 1rem 0">
                <vs-checkbox
                  class="mt-3 font-semibold"
                  v-model="channelInfo.isLocalChannel"
                  >{{ $t("setup.label.IsLocalChannel") }}</vs-checkbox
                >
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="vx-col w-full" style="margin: 1rem 0">
                <vs-checkbox
                  class="mt-3 font-semibold"
                  v-model="channelInfo.isHdChannel"
                  >{{ $t("setup.label.IsHdChannel") }}</vs-checkbox
                >
              </div>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <ValidationProvider
                rules="required|numeric"
                v-slot="{ errors }"
                :name="$t('setup.label.ChannelSequence')"
              >
                <vs-input
                  :label="$t('setup.label.ChannelSequence')"
                  class="w-full mb-2 font-semibold"
                  v-model="channelInfo.channelSequence"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label font-semibold">{{
                  $t("setup.label.Genre")
                }}</small>
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('setup.label.Genre')"
                >
                  <v-select
                    v-model="channelInfo.channelCategory"
                    :options="channelCategorys"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :reduce="(option) => option.value"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full"
                  >
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label font-semibold">{{
                  $t("setup.label.ChannelType")
                }}</small>
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('setup.label.ChannelType')"
                >
                  <v-select
                    label="name"
                    v-model="channelInfo.channelType"
                    :options="channelTypes"
                    :placeholder="$t('placeholder.label.SelectOne')"
                  >
                    <template v-slot:option="option">{{
                      option.name
                    }}</template></v-select
                  >
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label font-semibold">{{
                  $t("setup.label.BroadcasterId")
                }}</small>
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('setup.label.BroadcasterId')"
                >
                  <v-select
                    label="broadcasterName"
                    v-model="channelInfo.broadcasterId"
                    :options="channelTemplate.broadcasterDatas"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :reduce="(name) => name.id"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full"
                  >
                    <template v-slot:option="option">{{
                      option.broadcasterName
                    }}</template>
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
          </div>
        </vx-card>
      </div>
      <div class="vx-row center">
        <div class="vx-col w-full">
          <vs-button
            color="primary"
            type="border"
            class="mb-2 footerButton-cancel"
            @click="cancel"
            >{{ $t("setup.label.Cancel") }}</vs-button
          >
          <vs-button
            class="mr-3 mb-2 footerButton-next"
            @click="updateChannel"
            >{{ $t("setup.label.Submit") }}</vs-button
          >
        </div>
      </div>
    </ValidationObserver>
    <validation-popup
      :errorMessage="errorMessage"
      :warningPopup="warningPopup"
      :warningText="warningText"
      @closeWarning="warningPopup = false"
    ></validation-popup>
  </div>
</template>
<script>
import vSelect from "vue-select";
import { mapState } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";

const channelEmptyObj = {
  isHdChannel: false,
  broadcasterId: "",
  channelName: "",
  broadcasterName: "",
  channelCategory: "",
  channelSequence: "",
  channelType: "",
  isLocalChannel: false,
  language: "",
};
export default {
  data() {
    return {
      warningPopup: false,
      warningText: "",
      errorMessage: "",
      channelInfo: channelEmptyObj,
      channelTypes: ["Pay", "FTA"],
      broadcasters: [],
      channelCategorys: [],
      broadcast_: "",
      selected: "",
    };
  },
  components: {
    "v-select": vSelect,
    ValidationProvider,
    ValidationObserver,
  },

  computed: {
    ...mapState({
      channelTemplate: (state) => state.broadcaster.channelTemplate,
      channelById: (state) => state.broadcaster.channelById,
    }),
  },
  methods: {
    async getChannelTemplate() {
      try {
        await this.$store.dispatch("broadcaster/setChannelTemplate");
        let i = 0;
        for (let temp of this.channelTemplate.broadcasterDatas) {
          this.broadcasters = [...this.broadcasters, { label: "", value: "" }];
          this.broadcasters[i].value = temp.id;
          this.broadcasters[i].label = temp.broadcasterName;
          i += 1;
        }
        let j = 0;
        for (let temp of this.channelTemplate.channelCategorys) {
          this.channelCategorys = [
            ...this.channelCategorys,
            { label: "", value: "" },
          ];
          this.channelCategorys[j].value = temp.mCodeValue;
          this.channelCategorys[j].label = temp.mCodeValue;
          j += 1;
        }
        this.getChannelData();
      } catch (e) {
        this.$toasted.error(e.message);
      }
    },
    async getChannelData() {
      try {
        await this.$store.dispatch(
          "broadcaster/setChannelById",
          this.$route.params.id
        );
        this.channelInfo = this.channelById;
      } catch (e) {
        this.$toasted.error(e.message);
      }
    },
    async updateChannel() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;

      delete this.channelInfo.id;

      try {
        await this.$store.dispatch("broadcaster/updateChannelAction", {
          id: this.$route.params.id,
          data: this.channelInfo,
        });
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Channel Edited Successfully!",
          type: "success",
        });
        this.$router.push(`/setup/broadcaster-channel`);
        this.resetForm();
      } catch (error) {
        const errorMessage = String(error).replace(/^Error:\s*/, "");
        this.$swal({
          title: "Error",
          icon: "error",
          html: `<div style="text-align: center;">${errorMessage}</div>`,
          type: "error",
        });
      }
    },
    resetForm() {
      this.channelInfo = channelEmptyObj;
    },
    cancel() {
      this.$router.push(`/setup/broadcaster-channel`);
    },
  },
  mounted() {
    this.getChannelTemplate();
  },
};
</script>
